module.exports = "/_next/static/images/projectsEnergy3-dff8fa2bf6114628024e6fc0da52c6c1.webp";